<template>
    <div>
        <a class="text-no-decoration" @click="toggleFilter">
            <div class="d-flex flex-align-center badge-selected-item mb-2 mr-2">
                <div class="d-flex flex-wrap mr-1" :class="!isMobile && 'text-uppercase'">
                    {{ label }}
                </div>
                <i
                    v-if="isMobile"
                    class="icon-cr icon-close"
                    style="width: 0.7rem; height: 0.7rem"
                ></i>
            </div>
        </a>
    </div>
</template>

<script>
    import CatalogFilterLink from './CatalogFilterLink.vue';

    export default {
        name: 'CatalogClearFiltersItem',
        extends: CatalogFilterLink,

        props: {
            isMobile: Boolean,
        },
    };
</script>
